module.exports = __webpack_public_path__ + "img/minamitsu murasa_sc2.19f1267b.png";